<template>
  <div class="ma-4">
    <snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-2" v-if="!edicao">Cadastro de Rota</div>
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição da Rota"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.group"
            :error-messages="groupErrors"
            :items="grupos"
            outlined
            label="Grupo"
            @input="$v.form.group.$touch()"
            @blur="$v.form.group.$touch()"
          />
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Ações"
        :valoresDisponiveisComboBox="acoesDisponiveis"
        @dragUpdate="updateAcoes($event)"
        :opcoesSelecionadas="acoesSelecionadas"
        class="mr-4"
      />

      <div v-for="n in 4" :key="`divider_${n}`">
        <v-divider vertical />
      </div>

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import DraggAndDrop from '../_components/DraggAndDrop'
import rotasHttpService from '../_services/rotasHttpService'
import RotaStore from '../_store'
import acoes from '../_components/acoes'
import { validateData, validateComputed } from '../_validates'

export default {
  name: 'RotasSaida',
  props: {
    edicao: String,
    _id: String,
    copy: Boolean,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      group: '',
      regex: [],
    },
    acoesSelecionadas: [],
    acoesDisponiveis: [...acoes],
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
    grupos: []
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('cadastroRotasModulePABXStore', ['getRotaSelecionada', 'getGrupos']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroRotasModulePABXStore', RotaStore)

    await this.listarGruposRotas()

    this.getGrupos.forEach(grupo => {
      this.grupos.push({ text: grupo.description, value: grupo._id })
    })

    if (this.edicao === 'true' || this.copy) {
      await this.selecionarRota(this._id)

      if(this.copy) {
        this.form.description = "Copia de " + this.getRotaSelecionada.description
      } else {
        this.form.description = this.getRotaSelecionada.description
      }
      
      this.form.group = this.getRotaSelecionada.group
      this.form.regex = this.getRotaSelecionada.regex

      this.acoesSelecionadas = Object.values(this.getRotaSelecionada.regex)
    }

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('cadastroRotasModulePABXStore', ['selecionarRota', 'listarGruposRotas']),
    updateAcoes(event) {
      this.form.regex = event.map((element, key) => ({ ...element, prioridade: key + 1 }))
    },

    async salvar() {
      this.pararLoader.parar = false

      if (this.form.regex.length > 0) {
        const count = this.form.regex.filter(reg => !reg.acao.centroDeCusto).length

        if (count > 0) {
          this.text = 'Favor inserir os valores dentro da ação selecionada.'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        }
      }
      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this._id && this.edicao === 'true') {
          delete this.form.numero
          await rotasHttpService.putrota(this.form, this._id)
        } else {
          await rotasHttpService.postrota(this.form)
        }
        this.$router.push({ name: 'Rotas' })
      } catch (error) {
        this.text = error.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Rotas' })
    },
  },
}
</script>
